import { setCookie as writeCookie, getCookie } from '../utils/cookies'

let productIds

function checkCookie() {
    const latest_product_cookies = getCookie('latest_product_cookies')
    if (latest_product_cookies != null && latest_product_cookies != undefined && latest_product_cookies != '') {
        productIds = JSON.parse(latest_product_cookies)
    } else {
        productIds = []
    }
}

document.addEventListener('DOMContentLoaded', checkCookie)

// Lägger till en produkt-id i listan och skriver tillbaka hela JSON-arrayen.
function setCookie(cName, productId, expDays) {
    if (!productIds) {
        productIds = []
    }
    productIds.push(productId)
    writeCookie(cName, JSON.stringify(productIds), expDays)
}

const products = document.querySelectorAll('.product-item, li.product')
products.forEach((product) => {
    product.addEventListener('click', function () {
        const cookieId = product.querySelector('[data-post-id]').dataset.postId
        setCookie('latest_product_cookies', cookieId, 30)
    })
})
